import { render, staticRenderFns } from "./commentAdd.vue?vue&type=template&id=1ad0bc08&scoped=true&"
import script from "./commentAdd.vue?vue&type=script&lang=js&"
export * from "./commentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad0bc08",
  null
  
)

export default component.exports